import { atomWithReset } from 'jotai/utils';

import {
  type CountryLangFilters,
  INITIAL_COUNTRY_LANG_FILTERS,
} from '../../types/countryLangFilters';

/**
 * Átomo com o estado dos filtros (client-side) da listagem de Idiomas do país.
 *
 * Deve ser consumido apenas via `useCountryLangFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const countryLangFiltersAtom = atomWithReset<CountryLangFilters>(
  INITIAL_COUNTRY_LANG_FILTERS,
);
